<!--  查看、编辑提醒信息 -->
<template>
  <div class="addCheck">
    <el-drawer
      :title="title"
      :visible.sync="userOpenFlag"
      @close="handleClose"
      @open="openMap"
      direction="rtl"
      size="40%"
    >
      <div class="demo-drawer__content">
        <div>
          <el-form
            :model="form"
            :rules="warningFormRules"
            ref="warningForm"
            :label-position="'top'"
            size="small"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item class="width-max" label="提醒时间">
                  <el-input v-model="form.warningDate" :readonly="true">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item class="width-max" label="提醒内容">
                  <el-input
                    :readonly="true"
                    v-model="form.warningContent"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="form.isUrge">
              <el-col :span="12">
                <el-form-item class="width-max" label="催办完成时间">
                  <el-input v-model="form.urgeDate" :readonly="true">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="width-max" label="催办人">
                  <el-input v-model="form.urgerName" :readonly="true">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  class="width-max"
                  label="催办完成要求"
                  prop="dates"
                >
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    :readonly="true"
                    v-model="form.urgeContent"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item class="width-max" label="处理完成回复">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    placeholder="请输入回复内容"
                    :readonly="!isEdit"
                    v-model="form.dealWithContent"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item class="width-max" label="处理完成时间">
                  <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="form.dealWithDate"
                    type="datetime"
                    :readonly="!isEdit"
                    placeholder="选择处理完成时间"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item class="width-max" label="附件">
                  <el-upload
                    action="#"
                    :limit="10"
                    :disabled="!isEdit"
                    list-type="text"
                    :on-change="handleChangeReviewPic"
                    :on-remove="handleRemove"
                    :on-preview="
                      (file) => {
                        handlePictureCardPreview(file, form.files);
                      }
                    "
                    :accept="accept"
                    :auto-upload="false"
                    :file-list="form.files"
                  >
                    <el-button
                      slot="default"
                      :disabled="!isEdit"
                      size="small"
                      type="primary"
                      >点击上传</el-button
                    >
                    <div slot="tip" class="el-upload__tip"></div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="demo-drawer__footer">
        <el-button type="primary" @click="saveData" v-if="isEdit"
          >保存</el-button
        >
        <el-button @click="userOpenFlag = false">取消</el-button>
      </div>
    </el-drawer>
    <el-dialog :modal="false" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { DownloadBlob } from "@/http/downloadService";

export default {
  name: "editWarning",
  props: {},
  computed: {
    isEdit() {
      return this.title == "编辑";
    },
  },
  data() {
    return {
      accept: ".png,.jpg,.jpeg,.doc,.docx,.xls,.xlsx,.pdf",
      warningFormRules: {
        // yearPlanOutPut: [
        //   { required: true, message: "请输入本年度计划产生量", trigger: "blur" },
        // ],
        // yearPlanDisPosVol: [
        //   { required: true, message: "请输入本年度计划处置量", trigger: "blur" },
        // ],
        // isTransProvince: [
        //   { required: true, message: "请选择是否跨省转移", trigger: "change" },
        // ],
        // handleCompany: [
        //   { required: true, message: "请输入处置单位", trigger: "blur" },
        // ],
        // handleType: [
        //   { required: true, message: "请选择处置方式", trigger: "change" },
        // ],
        // dangerWasterListId: [
        //   { required: true, message: "请选择危废名称", trigger: "change" }
        // ],
      },
      title: "编辑",
      dialogVisible: false,
      dialogImageUrl: "",
      dates: [],
      userOpenFlag: false,
      form: {
        id: 0,
        companyName: "",
        uniformSocialCreditCode: "",
        serveType: null,
        serviceContent: "",
        officialWebsite: "",
        contactPerson: "",
        tel: "",
      },
    };
  },
  methods: {
    // 上传图片
    handleChangeReviewPic(file, fileList) {
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      const accept = this.accept.split(",");

      if (!accept.includes(suffix)) {
        this.$message({
          message: `不支持上传${suffix}类型的文件`,
          type: "warning",
        });
        this.form.files = [];
        return false;
      }

      let arr = [];
      fileList.map((item) => {
        arr.push(item.raw);
      });
      this.form.uploadFiles = arr;
      this.form.files = fileList;
    },
    //   删除图片
    handleRemove(file, fileList) {
      if (file.id) {
        this.form.deletedIds.push(file.id);
      }
      let arr = [];
      fileList.map((item) => {
        arr.push(item.raw);
      });
      this.form.uploadFiles = arr;
      this.form.files = fileList;
    },
    // 查看大图
    handlePictureCardPreview(file, fileList) {
      let url = file.url2;
      let data = {};
      let config = {
        url: url,
        data: data,
      };
      DownloadBlob(config);
    },
    lookDrawerOpen(val, title = "编辑") {
      this.title = title;
      //编辑

      if (val) {
        let url = this.$api.warnings.warnings + "/" + val;
        this.$axios
          .get(url, false)
          .then((res) => {
            let datas = res.data.data;
            if (datas.hasOwnProperty("files")) {
              datas.files.forEach((item) => {
                item.url2 = item.url;
                item.url = item.base64;
              });
            }
            //   深拷贝一下解决点击编辑时弹窗不重置问题
            let formModel = Object.assign({}, datas);
            this.$nextTick(() => {
              formModel.deletedIds = [];
              this.form = formModel;
            });
          })
          .catch((err) => {
            console.log("失败");
          });
      }
      this.userOpenFlag = true;
    },
    // 弹窗打开时初始化事件
    openMap() {
      this.$nextTick(() => {});
    },
    handleClose() {},
    saveData() {
      this.$refs.warningForm.validate((valid) => {
        if (valid) {
          const { deletedIds, urgeDate, urgerName, urgeContent, ...datas } =
            this.form;
          // let datas = { id, dealWithDate, dealWithContent, uploadFiles };

          if (deletedIds.length > 0) {
            datas.deletedIds = deletedIds;
          }
          let formData = new FormData(); //  用FormData存放上传文件
          for (let p in datas) {
            if (datas.hasOwnProperty(p)) {
              let data = datas[p];
              if (Array.isArray(data)) {
                if (p === "uploadFiles") {
                  data.forEach((t) => {
                    if (t) {
                      formData.append(p, t);
                    }
                  });
                } else if (p === "deletedIds") {
                  formData.append(p, data);
                }
              } else {
                formData.append(p, data);
              }
            }
          }
          let url = this.$api.warnings.dealWithWarning;

          this.$axios.post(url, formData, false).then((res) => {
            if (res.data.code == 0) {
              this.userOpenFlag = false;
              this.$parent.getList();
              this.$message({
                type: "success",
                message: res.data.msg,
              });
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });

      // let formData = this.form;
      // let url = this.$api.tzSolids.tzSolids;
      // this.$axios.post(url, formData, false).then((res) => {
      //   if (res.data.code == 0) {
      //     this.$message({
      //       type: "success",
      //       message: res.data.msg,
      //     });
      //     this.$parent.getList();
      //     this.userOpenFlag = false;
      //   } else {
      //     this.$message({
      //       type: "error",
      //       message: res.data.msg,
      //     });
      //   }
      // });
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {
    // this.list = this.states.map((item) => {
    //   return { value: `value:${item}`, label: `label:${item}` };
    // });
  },
};
</script>

<style lang="scss" scoped>
.addCheck {
  /deep/.el-drawer__body {
    position: relative;
  }

  /deep/.el-dialog__header {
    display: none;
  }

  .demo-drawer__footer {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>